module.exports = __webpack_public_path__ + "img/catch.756b1cc0.jpg";